import { put } from 'core/middlewares/utilities';
import { app, cart } from 'core/use-cases';

import { getters } from './getters';

import type { Checkout } from 'core/domains';

/**
 *
 *
 */

export function* giftInit() {
  const { canSubmit, isRunning }: getters.Cart = yield getters.getCart();
  const {
    rewards: { status },
    isRunning: isRunningCheckout,
  }: Checkout = yield getters.getCheckout();

  if (isRunning || status === 'running') {
    return;
  }

  if (canSubmit && !isRunningCheckout) {
    yield put(cart.actions.cartFetchForGiftsCheck.request());
  }
}
